import { NgClass, NgFor } from '@angular/common';
import { Component, inject } from '@angular/core';
import { PaButtonComponent } from 'src/app/shared/ui-kit/pa-button/pa-button.component';
import { environment } from 'src/environments/environment';
import { SupportLinkV2Component } from '../../components/support-link/support-link.component';
import { LoginAccountOption } from '../../models/login-v2-api.models';
import { AuthActionsService } from '../../services/auth-actions.service';
import { AuthFlowService } from '../../services/auth-flow.service';
import { AuthSessionStore } from '../../services/auth-session.store';

@Component({
  selector: 'app-select-account-step',
  standalone: true,
  imports: [NgFor, NgClass, PaButtonComponent, SupportLinkV2Component],
  templateUrl: './select-account-step.component.html',
  styleUrls: ['../../styles/_step.styles.scss'],
})
export class SelectAccountStepComponent {
  readonly environment = environment;
  readonly store = inject(AuthSessionStore);
  private readonly flow = inject(AuthFlowService);
  private readonly actions = inject(AuthActionsService);

  back(): void {
    this.flow.goBack();
  }

  selectAccount(id: number): void {
    this.actions.selectAccount(id);
  }

  accountMeta(account: LoginAccountOption): string {
    if (account.owner_name !== account.name) {
      return `${account.role} · Руководитель: ${account.owner_name}`;
    }

    return account.role;
  }
}
